import React from 'react';
import { Users, Group, BarChart3, Shield, SlidersHorizontal } from 'lucide-react';

const TABS = [
  { id: 'customers', label: 'Initiatives', icon: Users },
  { id: 'groups', label: 'Monitoring', icon: Group },
  { id: 'modelEvaluation', label: 'Model Evaluation', icon: BarChart3 },
  { id: 'guardrails', label: 'Guardrails', icon: Shield },
  { id: 'llmConfig', label: 'LLM Config', icon: SlidersHorizontal },
];

const TabSelector = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex gap-4 sm:gap-8 overflow-x-auto whitespace-nowrap pb-1">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              className={`py-4 px-1 border-b-2 font-medium text-sm shrink-0 ${
                activeTab === id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center">
                <Icon className="w-5 h-5 mr-2" />
                {label}
              </div>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabSelector;